import { useState, useEffect, memo, HTMLAttributes } from "react"
import { SnsFb, SnsTw } from './sns'

type HeaderProps = {
  img?: string;
  imgAlt?: string;
  titleText?: string;
} & HTMLAttributes<any>

export const CorpHeader = memo((props: HeaderProps) => {
  const [smoothStyle, setSmoothStyle] = useState("smoothTextTrigger")
  const [hdrClass, setHdrClass] = useState('nav-init')
  const [openMenu, setOpenMenu] = useState(false)
  const menuFunction = () => {
    setOpenMenu(!openMenu)
  }

  useEffect(() => {
    let gnavScrlPos = 0
    const scrollLister = () => {
      const y = window.scrollY
      if (y <= 0) {
        setHdrClass('nav-init')
      } else if (y - gnavScrlPos > 0) {
        setHdrClass('UpMove')
      } else if (y - gnavScrlPos < -10) {
        setHdrClass('DownMove')
      }
      gnavScrlPos = y
    }
    window.addEventListener('scroll', scrollLister)
    setSmoothStyle("smoothTextTrigger smoothTextAppear")
    return function cleanUp() {
      window.removeEventListener('scroll', scrollLister)
    }
  }, [smoothStyle])

  return <>
    <header className="hdr">
      <nav id="hdr__menu" className={`hdr__menu ${openMenu ? "panelactive" :""}`}>
        <div className="menu__list">
          <ul className="menu__list__primary">
            <li><a href="./index.html" target="_self">トップ</a></li>
            <li className="hide-noservice"><a href="./service.html" target="_self">サービス</a></li>
            {/* <li className="hide-noservice"><a href="./usersvoice.html" target="_self">利用者の声</a></li> */}
            <li><a href="./vision.html" target="_self">ビジョン</a></li>
            <li><a href="./topics.html" target="_self">トピックス</a></li>
          </ul>
          <ul className="menu__list__secondary">
            <li><a href="./company.html" target="_self">会社概要</a></li>
            <li className="hide-nofaq"><a href="./faq.html" target="_self">よくある質問</a></li>
            <li className="hide-nocontact"><a href="./contact.html" target="_self">お問い合わせ</a></li>
            <li><a href="./termsofuse.html" target="_self">利用規約</a></li>
            <li><a href="./privacypolicy.html" target="_self">プライバシーポリシー</a></li>
            <li><a href="./informationProvision.html" target="_self">提携先企業との情報提供</a></li>
            <li><a href="./salespolicy.html" target="_self">特定商取引に基づく表記</a></li>
            <li><a href="./premiumContract.html" target="_self">プレミアムプラン利用規約</a></li>
            <li><a href="./externaltransmission.html" target="_self">お客さま情報の外部送信について</a></li>
          </ul>
          <div className="menu__list__copy">
            <ul className="menu__list__sns">
              <li className="hide-sns-fb"><SnsFb /></li>
              <li className="hide-sns-fb"><SnsTw /></li>
            </ul>
            <small>&copy; SMBC FAMILY WORKS</small>
          </div>
        </div>
      </nav>
      <div id="hdr__nav" className={`hdr__nav ${openMenu ? "nav-init panelactive" : `${hdrClass}`}`}>
        <h1><a href="./index.html" target="_self" className="hdr__nav__logo">Family Works</a></h1>
        <nav id="hdr__nav__nav">
          <ul>
            <li className="hide-noservice"><a href="./service.html" target="_self">サービス</a></li>
            {/* <li className="hide-noservice"><a href="./usersvoice.html" target="_self">利用者の声</a></li> */}
            <li><a href="./vision.html" target="_self">ビジョン</a></li>
            <li><a href="./topics.html" target="_self">トピックス</a></li>
          </ul>
        </nav>
        <div className={`btnMenu ${openMenu ? "active" : ""}`} onClick={menuFunction}><span></span><span></span></div>
      </div>
      <div className="hdr__title">
        {props.titleText && <div className="hdr__title__wrapper">
          {props.img && <div className="hdr__title__e"><span className="smoothText"><span><img src={props.img} alt={props.imgAlt} /></span></span></div>}
          <div className="hdr__title__j"><h2><span className="smoothText"><span>{props.titleText}</span></span></h2></div>
        </div>}
      </div>
    </header>  </>
})